
ScrollTrigger.matchMedia({
  "(min-width: 1280px) and (max-width: 1480px)": function () {
      const topTl = gsap.timeline({
        scrollTrigger: {
          trigger: ".p-about-message",
          start: "top top",
          end: "+=400",
          scrub: true,
          pin: true,
        },
      });
      // スクロール時のアニメーション
      topTl.fromTo(
        ".p-about-message__pc-text",
        {
          y: '12%'
        },
        { 
          y: '-85%'
        }
    );
  },
  "(min-width: 1481px) and (max-width: 1679px)": function () {
    const topTl = gsap.timeline({
      scrollTrigger: {
        trigger: ".p-about-message",
        start: "top top",
        end: "+=400",
        scrub: true,
        pin: true,
      },
    });
    // スクロール時のアニメーション
    topTl.fromTo(
      ".p-about-message__pc-text",
      {
        y: '15%'
      },
      { 
        y: '-85%'
      }
  );
},
  "(min-width: 1680px)": function () {
    const topTl = gsap.timeline({
      scrollTrigger: {
        trigger: ".p-about-message",
        start: "top top",
        end: "+=400",
        scrub: true,
        pin: true,
      },
    });
    // スクロール時のアニメーション
    topTl.fromTo(
      ".p-about-message__pc-text",
      {
        y: '20%'
      },
      { 
        y: '-80%'
      }
  );
}
})